import {EventHandler, FC, PropsWithChildren} from "react";
import "./BadgeBar.scss";

export interface BadgeBarProps {
  id?: string;
  className?: string;
  onClick?: EventHandler<any>;
}

export const BadgeBar: FC<PropsWithChildren<BadgeBarProps>> = ({
  id,
  className,
  onClick,
  children
}) => {
  return (
    <div
      id={id}
      data-testid={id}
      className={className ? `coat-badge-bar ${className}` : "coat-badge-bar"}
      onClick={onClick}>
      {children}
    </div>
  );
};
